var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Typography } from '../../Typography';
import "./styles.css";
export var Chip = forwardRef(function (_a, ref) {
    var label = _a.label, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.dragged, dragged = _d === void 0 ? false : _d, onClick = _a.onClick, className = _a.className, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, props = __rest(_a, ["label", "active", "disabled", "dragged", "onClick", "className", "startAdornment", "endAdornment"]);
    return (React.createElement("button", __assign({ tabIndex: onClick ? 0 : -1, onClick: !disabled ? onClick : undefined, className: classNames('lk-ui_chip', active && 'lk-ui_chip__active', disabled && 'lk-ui_chip__disabled', startAdornment && 'lk-ui_chip__start-icon', endAdornment && 'lk-ui_chip__end-icon', !!onClick && 'lk-ui_chip__clickable', dragged && 'lk-ui_chip__dragged', className) }, props, { ref: ref }),
        startAdornment && (React.createElement("div", { className: 'lk-ui_chip-start-icon' }, startAdornment)),
        React.createElement(Typography, { variant: 'body3', className: 'lk-ui_chip-title' }, label),
        endAdornment && (React.createElement("div", { className: 'lk-ui_chip-end-icon' }, endAdornment))));
});
